export default __webpack_public_path__ + "static/media/location-new.51effde2.svg";